import React, { Suspense } from 'react'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import throttle from 'lodash/throttle'
import once from 'lodash/once'
import moment from 'moment'
import sessionStorage from 'sessionstorage'
import querystring from 'query-string'

import { Route } from 'react-router-dom'
import { mark } from '@pcln/measure'

import { Check } from 'pcln-icons'
import { flyGaLogic } from '../../util/flyGaLogic'
import { CrossSellGenericAd } from '../Legacy/cross-sell-generic-ad'
import { flyDetailDeeplinkModel } from '../Legacy/fly-detail-deeplink-model/fly-detail-deeplink-model-factory'
import { flyFilterSelectionHistoryStorage } from '../Legacy/fly-filter-selection-history-storage/fly-filter-selection-history-storage'

import { flySearchRetailFilter } from '../../util/flySearchRetailFilter'
import { flySliceSelectionStorage } from '../Legacy/fly-slice-selection-storage/fly-slice-selection-storage'
import { flyTripSelection } from '../../util/flyTripSelection'
import { RoutingHelper } from '../../util/routingHelper'
import { scrollState } from '../Legacy/scroll-state/scroll-state'
import { translateSearchRequest } from '../../util/translateSearchRequest'
import { SETI } from '../../util/transformSETI'
import { userLoginData } from '../../util/userLoginData'
import { isDesktopVP } from '../../util/displayHelpers'
import { europeanCountriesList } from '../../../details-client/BaggageFeeComponent/helpers/europeanCountriesList'
import {
  buildCheckoutQuery,
  cancellationText,
} from '../../util/listingsHelpers'

import { OverlayManager } from '../../../common-components/Overlay/OverlayManager'

import { logSearchError } from '../../util/clientLogger'
import { ScrollLock } from '../../util/ScrollLock'
import { SBS_ROUTES, setSbsRouteParam } from '../../util/setSbsRouteParam'
import { LoaderContainer } from '../Loader/LoaderContainer'

import {
  filterTimer,
  showLoadingScreen,
  showLoadingScreenServerSide,
  sliceSelectionTrigger,
} from '../Legacy/events/events'
import { pclnGptDartAds } from '../Ad/gpt-dart-ad'
import { pclnExpt } from '../../../common/fly-experimentation/fly-experimentation'
import { flexDatesFlyinHelper } from '../../../common/FlyInHelper/flyin-helper'
import { newTabDetailsWithUpsell } from '../../util/brandedFares/newTabDetailsWithUpsell/newTabDetailsWithUpsell'
// eslint-disable-next-line import/no-restricted-paths
import { assetURLs } from '../../../../server/constants/assetURLs'
import { FilterRouteContainer } from '../Filters/FilterRoute/FilterRouteContainer'
import { PERF_EVENTS } from '../../../common/constants/perfEvents'
import { sliceBySliceTabs, defaultSelectedTab } from '../../constants/constants'
import { fireFlyConditions } from '../../constants/fireflyCondition'
import {
  buildInitialTabState,
  buildInitialTabStateMD,
} from '../../helpers/helpers'
import { populateListingsState } from './populateListingsState'
import { airSearchRequestModel } from '../../services/airSearch/airSearchRequest'
import { getCustomerVipTier } from '../../../services/profileql'
import { generatePhoneBookNumber } from '../../../services/phoneBookCall'

import {
  getItemList,
  logItemList,
  getStaticItemEventsData,
  getDynamicItemEventsData,
} from '../../../common/log-ga-event/logGaEvent-view-item-list'
import { logSelectItem } from '../../../common/log-ga-event/logGaEvent-select-item-listings'
import { logChangeFlight } from '../../../common/log-ga-event/logGaEvent-internal-link'
import { getIsSbs, getIsLastSlice, getNumSlices } from '../../util/sbs'

const LazyContentRenderer = React.lazy(() =>
  import(/* webpackPrefetch */ './ContentRenderer')
)

class ListingsContent extends React.PureComponent {
  constructor(props, context) {
    super(props)

    if (typeof window === 'undefined') {
      return
    }

    const translatedRequest = translateSearchRequest(
      props.pclnBootstrapData.searchRequest
    )

    const {
      airports,
      searchReqAirports,
      slices,
      cabinClass,
      travelers,
      tripType,
      departingFrom,
      returningFrom,
      travelDate,
      returnDate,
      origin,
      destination,
    } = translatedRequest
    this.airports = airports
    this.origin = origin
    this.destination = destination
    this.cabinClass = cabinClass

    const filterHistory = flyFilterSelectionHistoryStorage

    /**
     * Listen for slice selection event
     * TODO: Convert this to React function/DELETE BELOW LISTENER
     */
    sliceSelectionTrigger.subscribe(value => {
      filterHistory.save(
        {
          sliceFilter: value.sliceFilterParam,
          selected: value.isSelect,
        },
        value.isSelect
      )

      filterTimer.dispatch(new Date())
      if (value.isSelect) {
        flySliceSelectionStorage.set(value.sliceFilterParam)
        flyGaLogic.fire.sliceSelection('Slice filter', value.gaLabel)
      } else {
        flySliceSelectionStorage.remove(value.sliceFilterParam)
      }

      this.setState(
        {
          isSliceSelected: value.isSelect,
        },
        () => {
          this.makeSliceSelection('sliceSelection')
        }
      )
    })

    /**
     * TODO: Too many loading flags, delete the unused ones
     * */
    showLoadingScreen.subscribe(val => {
      this.setState({
        showLoadingMessage: val.type,
        loadingMessage: val.msg,
        loadingMessageOffsetTop: val.offset,
      })
    })

    this.overlayManager = new OverlayManager()
    this.routingHelper = new RoutingHelper(this.props.history)
    this.appLoadTimestamp = new Date()
    this.scrollLock = null

    const isFireFly = fireFlyConditions.isFireFly()
    const numSlices = getNumSlices()
    /**
     * TODO: Move props out of state that are not updated
     */
    this.state = {
      slicesURL: get(props.pclnBootstrapData, 'searchRequest.slicesURL'),
      listings: [],
      phoneBookInfo: {},
      sbsListings: {
        1: [],
      },
      tabs:
        tripType === 'MD'
          ? buildInitialTabStateMD(
              numSlices,
              defaultSelectedTab,
              this.updateActiveTabIdAndFilters
            )
          : buildInitialTabState(
              sliceBySliceTabs,
              defaultSelectedTab,
              this.updateActiveTabIdAndFilters
            ),
      lastUpdateTime: null,
      listingsLoadTimerStart: new Date(),
      loadingMessage: props.listingsLoadingMessage,
      searchKey: '',
      options: {
        adCount: 0,
        adsLength: pclnGptDartAds.length,
      },
      airportToCity: {},
      loadingMessageOffsetTop: null,
      showLoadingMessage: true,
      filter: flySearchRetailFilter(),
      loadMoreRequestPending: false,
      showBaggageFeeModal: false,
      showErrorOverlay: get(props.pclnBootstrapData, 'hasBookingError', false),
      handleResize: throttle(this.handleResize, 300), // TODO: Check this later on
      isDesktop: isDesktopVP(),
      isSBS: tripType === 'OW' || getIsSbs(),
      isFireFly,
      isSBSQL: !isFireFly,
      priceGuidance: {},
      seti: SETI,
      flySliceSelectionStorage,
      filterHistory,
      searchReqAirports,
      slices,
      cabinClass,
      travelers,
      tripType,
      departingFrom,
      returningFrom,
      travelDate,
      returnDate,
      origin,
      destination,
      // Fire Impressions only Once after the initial Listings load
      fireListingsImpressionsOnce: false,
      vipTier: 'member',
    }

    this.perPaxPricingText = tripType === 'RT' ? 'round-trip' : 'per person'

    this.airSearchPromise = context.airSearchPromise

    this.logInitialRenderComplete = once(this._logInitialRenderComplete)
    // Constructor End
  }

  _logInitialRenderComplete(label = 'complete') {
    flyGaLogic.fire.initialListingsRendering(label)
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (!prevState) {
      return null
    }
    const newState = {}

    const lastUpdateTime = get(nextProps, 'listings.lastUpdateTime')
    const isNewListingsLoad =
      lastUpdateTime && lastUpdateTime !== prevState.lastUpdateTime
    if (isNewListingsLoad) {
      const listingsState = populateListingsState({
        listingsContentState: prevState,
        listingsContentProps: nextProps,
      })
      Object.assign(newState, listingsState)
    }

    const prevActiveTab = prevState.tabs.find(tab => tab.isActive)
    const userHasSwitchedTab = nextProps.activeTabId !== prevActiveTab.tabId

    if (prevState.isSBS && userHasSwitchedTab) {
      newState.tabs = prevState.tabs.map(tab => {
        tab.isActive = tab.tabId === nextProps.activeTabId
        return tab
      })
    }

    if (prevState.isSBS && isNewListingsLoad) {
      newState.sbsListings[nextProps.activeTabId] = newState.listings
    }

    if (Object.keys(newState).length) {
      return newState
    }

    return null
  }

  async componentDidMount() {
    const { pclnBootstrapData, attributeFilterConditions } = this.props
    const { isUserSignedIn } = userLoginData
    const {
      searchRequest = {},
      features = {},
      partner = {},
    } = pclnBootstrapData
    window.addEventListener('resize', this.state.handleResize)

    if (partner?.products?.flight) {
      searchRequest.plfCode = partner.products.flight.plfCode
    }

    pclnExpt.fireImpression('AIR_BPG_PLACEMENT_UPDATE')
    pclnExpt.fireImpression('PKG_SHORTER_FLIGHT_PATH_PROMOS')

    // Make initial airSearch request only on client
    // awaiting because fetchAirSearchResponse dispatches listingsMetaData,
    // which is needed to get VIP tier below
    await this.props.fetchAirSearchResponse(
      pclnBootstrapData,
      this.state.seti,
      this.airSearchPromise,
      attributeFilterConditions
    )

    const userCGUID = get(
      pclnBootstrapData,
      'requestLocals.webstats.clientGUID',
      'd1f5c150c10cfdbec036e58c52a96455'
    )
    const requestId = get(
      pclnBootstrapData,
      'requestLocals.webstats.clientRequestId',
      'd1f5125'
    )
    const refId =
      pclnBootstrapData?.requestLocals?.referral?.sourceId +
      pclnBootstrapData?.requestLocals?.referral?.id

    const numOfPassengers = get(
      pclnBootstrapData,
      'searchRequest.numberOfPassengers',
      1
    )
    const cabinClass = get(
      pclnBootstrapData,
      'searchRequest.params.cabin-class',
      'ECO'
    )

    const isDomestic = get(pclnBootstrapData, 'hasUSDestinationsOnly', true)

    const getLengthofStay = moment(this.state.returnDate).diff(
      this.state.travelDate,
      'days'
    )

    const formattedPurchaseWindow = moment(this.state.listingsLoadTimerStart)
      .format()
      .split('T')[0]
    const purchaseWindow = moment(this.state.travelDate).diff(
      formattedPurchaseWindow,
      'days'
    )
    const airportsArray = Object.values(this.airports)
    const phoneBookInput = {
      requestId: requestId,
      cguid: userCGUID,
      refid: refId,
      clientDevice: this.state.isDesktop ? 'DESKTOP' : 'MOBILE',
      isTestNumber: false,
      advancedPurchaseWindow: purchaseWindow,
      currencyCode: 'USD',
      origCountryCode: airportsArray[0].countryCode,
      destCountryCode: airportsArray[1].countryCode,
      clientCountryCode: pclnBootstrapData?.requestLocals?.locale?.countryCode,
      clientIp:
        pclnBootstrapData?.requestLocals?.locale?.ipAddr ||
        pclnBootstrapData?.requestLocals?.customer?.clientIp,
      originAirport: this.state.departingFrom.airportCode,
      destinationAirport: this.state.returningFrom.airportCode,
      isInternational: !isDomestic,
      passengers: numOfPassengers,
      isError: this.props.listingsHasErrored,
      travelStartDate: this.state.travelDate,
      travelEndDate: this.state.returnDate,
      searchOptions: {
        cabinClass: cabinClass,
      },
      pageType: 'LISTINGS',
      tripType: this.state.tripType,
    }

    if (this.state.tripType !== 'OW') {
      phoneBookInput.lengthOfStay = getLengthofStay
    }

    if (this.state.tripType !== 'MD') {
      try {
        const phoneBookInfo = await generatePhoneBookNumber(phoneBookInput)
        this.setState({ phoneBookInfo })
      } catch (e) {
        logSearchError('Phone Book API Error', e)
      }
    }

    if (this.props.listingsMetaData?.hasExpressDeal && isUserSignedIn) {
      try {
        const { email, dmcCookie: token } = userLoginData
        const appVersion = pclnBootstrapData?.appVersion

        // Make recognizedCustomerProfile call to get VIP tier status
        const vipTier = await getCustomerVipTier(email, token, appVersion)
        this.setState({ vipTier: vipTier?.toLowerCase() })
      } catch (e) {
        logSearchError('Customer VIP Tier error', e)
      }
    }

    if (this.state.listings?.length > 0) {
      pclnExpt.fireImpression('AIR_LISTINGS_FILTER_PRICE_GREEN')

      if (this.props.airlinesFilter?.length > 1) {
        pclnExpt.fireImpression('AIR_LISTINGS_AIRLINE_FILTERS_ALPHABETICAL')
      }
    }

    this.scrollLock = new ScrollLock()

    const enableFlexDates = features?.flights?.flexDatesToggle

    const enableSOPQ = features?.whiteLabel?.flightsExpressDealsEnabled

    if (enableFlexDates) {
      this.props.fetchFlexDates(searchRequest, this.state.tripType, enableSOPQ)
    } // verify if EXD or not

    const los = isNaN(getLengthofStay) ? '' : getLengthofStay

    /**
     * -------- GA4 Tagging logic for view-item-list START: --------
     */

    const { activeTabId } = this.props
    const { filterHistory } = this.state
    const searchRequestParams = pclnBootstrapData.searchRequest.params

    // GA Static Events Data consistent throughout RT, MD, OW Trip selection
    const staticItemEventsData = getStaticItemEventsData({
      ...this.state,
      ...this.props,
      ap: purchaseWindow,
      los: los,
      cabinClass: this.cabinClass,
      airportsArray: airportsArray,
      searchRequestParams: searchRequestParams,
    })

    const searchEventDataOnMount = {
      ...staticItemEventsData,
      ...getDynamicItemEventsData(activeTabId, filterHistory), // Dynamic is for slice change on RT departure select.
    }

    const listingsGAAttributes = getItemList(
      this.state?.listings,
      searchEventDataOnMount
    )
    logItemList(listingsGAAttributes, searchEventDataOnMount)

    // For RT Departure trip Re-use:
    this.setState({
      staticItemEventsData: staticItemEventsData,
      listingsGAAttributes: listingsGAAttributes,
    })

    /**
     * -------- GA4 Tagging logic for view-item-list END --------
     */
  }

  componentDidUpdate(prevProps) {
    if (prevProps.lastUpdateTime !== this.props.lastUpdateTime) {
      this.airSearchMsToLoad = Math.ceil(new Date() - this.appLoadTimestamp)
    }

    if (this.props.activeTabId !== prevProps.activeTabId) {
      setSbsRouteParam(SBS_ROUTES[this.props.activeTabId])
      if (getIsLastSlice(this.props.activeTabId)) {
        // GA4 Tagging logic for RT return flights
        const searchEventDataOnUpdate = {
          ...this.state.staticItemEventsData,
          ...getDynamicItemEventsData(
            this.props.activeTabId,
            this.state.filterHistory
          ),
        }

        const listingsGAAttributes = getItemList(
          this.state?.listings,
          searchEventDataOnUpdate
        )
        logItemList(listingsGAAttributes, searchEventDataOnUpdate)

        //  Update state for RT arrival click handler tagging:
        this.setState({
          listingsGAAttributes: listingsGAAttributes,
        })
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.state.handleResize)
  }

  /**
   * SBS
   * For RT: This works only onClick of Departure Tab,
   * remove the sliceKey from SliceFilters so that it doesn't clash with other slice filter params
   * */
  updateActiveTabIdAndFilters = ({ id }) => {
    const prevTabId = this.props.activeTabId
    logChangeFlight(this.state.tripType)

    if (id === 1) {
      // clear any possible over filtered statuses when returning to departure tab
      // Update displayInfiniteScrollLoadMore flag to show "Load More" button when return
      this.props.setOverfilteredStatus(false)
      this.props.setDisplayInfiniteScrollLoadMore(true)
    }
    flySliceSelectionStorage.removeAboveTabId(id)
    airSearchRequestModel.setSliceRefId({ sliceRefId: [id] })
    this.setState({
      selectedDepartureSummaries: this.state.selectedDepartureSummaries.slice(
        0,
        id - 1
      ),
    })
    this.props.setTabDefaultFilters({ tabId: prevTabId })
    this.props.updateActiveTabId(id)
    this.props.loadSavedFilterInfo({ tabId: id })
  }

  loadMore = () => {
    // Only load more listings if there are no overlays open (e.g. mWeb details, filters). For some reason,
    // the infinite scroll component triggers when the scroll position within the overlay reaches the bottom.
    if (this.overlayManager.getOpenModalCount() < 1) {
      this.props.listingsLoadMore(
        this.props.pclnBootstrapData,
        this.state.listings,
        this.props.filterValues
      )
    }
  }

  handleResize = () => {
    this.setState({
      isDesktop: isDesktopVP(),
    })
  }

  handleDepartureSliceClick = newlySelectedDepartureItinerary => {
    // GA4 Tagging for Departure Flight
    // Update "ticket" array in state for logging on details load
    const selectedIndex = newlySelectedDepartureItinerary?.listingPosition - 1
    const itinAttribute = this.state?.listingsGAAttributes?.[selectedIndex]
    logSelectItem(itinAttribute)

    const sliceKey = get(
      newlySelectedDepartureItinerary,
      'slices[0].sliceKey',
      ''
    )
    const { activeTabId, updateActiveTabId } = this.props
    const { selectedDepartureSummaries = [], tripType } = this.state
    updateActiveTabId(activeTabId + 1)

    if (tripType === 'MD') {
      this.setState({
        selectedDepartureSummaries: [
          ...selectedDepartureSummaries,
          newlySelectedDepartureItinerary,
        ],
      })
    } else {
      this.setState({
        selectedDepartureSummaries: [newlySelectedDepartureItinerary],
      })
    }

    const prevSliceKey =
      selectedDepartureSummaries?.[selectedDepartureSummaries?.length - 1]
        ?.slices?.[0]?.sliceKey || ''

    const willMakeReturnSliceAirSearchCall =
      (prevSliceKey && prevSliceKey !== sliceKey) || !prevSliceKey

    window.scrollTo(0, 0)

    flySliceSelectionStorage.set({ sliceKey, sliceId: activeTabId })

    if (willMakeReturnSliceAirSearchCall) {
      this.makeSliceSelection('sliceSelection')
    } else {
      // Dont load previously saved filter info if new call is being made
      this.props.loadSavedFilterInfo({ tabId: 2 })
    }
  }

  // TODO: Simplify the logic
  retrieveCheckoutQuery = (itineraryKey, upsellToken, itinerary) => {
    let adults
    let youths
    let children
    let infants
    let cabinClass

    const { passengers, searchOptions } = airSearchRequestModel

    adults = passengers.adults
    youths = passengers.youth
    children = passengers.children
    infants = passengers.infants
    cabinClass = searchOptions.cabinClass || 'ECO'

    const { searchRequest } = this.props.pclnBootstrapData
    const { params = {} } = searchRequest

    const {
      type: desktopExD,
      seti: setiOverride, // May not be present
      'seti-default': setiOverrideDefault,
      'search-type': searchType,
      refclickid,
    } = params

    return buildCheckoutQuery({
      itinerary,
      adults,
      youths,
      children,
      infants,
      cabinClass,
      setiOverride,
      setiOverrideDefault,
      refclickid,
      desktopExD,
      tripType: this.state.tripType,
      searchType,
    })
  }

  buildDetailsUrl = (id, itinerary, checkoutUrl, searchKey, upsellToken) => {
    const { slicesURL } = this.state
    const offerToken = this.props.pclnBootstrapData?.offerToken

    if (upsellToken) {
      return newTabDetailsWithUpsell({
        token: upsellToken,
        slicesURL,
        itinerary,
        checkoutUrl,
        offerToken,
      })
    }
    return newTabDetailsWithUpsell({
      token: id,
      slicesURL,
      searchKey,
      itinerary,
      checkoutUrl,
      offerToken,
    })
  }

  goToDetails = (id, gaIndex, isUpsell) => {
    scrollState.set('y', window.pageYOffset)
    flyGaLogic.setRetailListingPosition(gaIndex)
    this.routingHelper.goToMobileDetails(id, this.searchRefId(), isUpsell)
  }

  onListingItemSelect = ({ id, itinerary, upsellToken }) => {
    const sessionSearchKey = airSearchRequestModel.searchSessionKey

    // GA4 tagging for RT Return flight
    const selectedReturnFlight = itinerary?.listingPosition - 1
    const itinAttribute = this.state?.listingsGAAttributes[selectedReturnFlight]
    logSelectItem(itinAttribute)

    if (
      itinerary?.itineraryLabel &&
      itinerary?.itineraryLabel?.shortText === 'RECOMMENDED'
    ) {
      flyGaLogic.fire.popularFlights('Click')
    }

    // AIR-22631: GA tag position rank of itinerary
    if (itinerary?.listingPosition > 30) {
      flyGaLogic.fire.retailListingsPositionClicked('30+')
    } else {
      flyGaLogic.fire.retailListingsPositionClicked(itinerary?.listingPosition)
    }

    const checkoutUrl = this.retrieveCheckoutQuery(id, upsellToken, itinerary)

    // TODO: NOT needed
    if (
      typeof Storage !== 'undefined' &&
      get(itinerary, 'merchandising.label') === 'CHEAPEST'
    ) {
      sessionStorage.setItem(
        `MERCH_${id}`,
        JSON.stringify([itinerary?.merchandising])
      )
    }

    const detailsUrl = this.buildDetailsUrl(
      id,
      itinerary,
      checkoutUrl,
      sessionSearchKey,
      upsellToken
    )

    window.open(
      `${detailsUrl}`,
      this.props.pclnBootstrapData?.features?.whiteLabel?.iframeEnabled
        ? '_self'
        : '_blank'
    )
  }

  onListingsMount = timerEnd => {
    mark(PERF_EVENTS.renderGraphListingsEnd)

    const timeToLoadListings = Math.abs(
      timerEnd - this.state.listingsLoadTimerStart
    )
    const loadingSeconds = ((timeToLoadListings % 60000) / 1000).toFixed(0)
    flyGaLogic.fire.listingsRenderTime(loadingSeconds)
    this.logInitialRenderComplete()
  }

  makeSliceSelection = (displayType = '') => {
    this.props.listingsFilterCall(this.props.pclnBootstrapData, displayType)
  }

  onSliceFilter = (slice, sliceId, selected, tripType) => {
    window.scrollTo(0, 0)
    flyTripSelection(slice, sliceId, selected, tripType, this.state.seti)
  }

  setBaggageFeeVisibility = show => {
    this.setState({
      showBaggageFeeModal: show,
    })
  }

  /**
   * TODO: Couldn't find reference in fly-listings for any of the following 3 functions
   * Delete them after AIR_FE_GRAPH_SEARCH task
   * */
  showLoadingScreenServerSide = bool =>
    showLoadingScreenServerSide.dispatch(bool)

  openBaggageFeesModal = () => this.setBaggageFeeVisibility(true)
  closeBaggageFeeOverlay = () => this.setBaggageFeeVisibility(false)

  setErrorOverlay = show => {
    this.logInitialRenderComplete('error-incomplete')
    this.setState({
      showErrorOverlay: show,
    })
  }

  closeErrorOverlay = () => this.setErrorOverlay(false)

  /**
   * TODO: Move it to a helper function
   * */
  getMinRetailStops = () => {
    let cheapestItin = get(this.state, 'listings', []).find(
      itin => !itin.isExpressDeal && !itin.crossSellAd && !itin.priceBreakers
    )

    let minStops

    if (cheapestItin) {
      minStops = cheapestItin.slices.reduce(
        (stops, slice) => stops + slice.stops,
        0
      )
    }

    return minStops
  }

  searchRefId = () => {
    const { pclnBootstrapData } = this.props
    const { requestLocals = {} } = pclnBootstrapData
    return (
      get(requestLocals, 'referral.sourceId', '') +
      get(requestLocals, 'referral.id', '')
    )
  }

  renderStaticElements = seti => {
    /**
     * CAUTION ~~ CODE SMELL: DO NOT ADD TO, MODIFY, OR ACCEPT CHANGES TO THIS FUNCTION.
     *
     * (ADDED 2019.04.24)
     *
     * THESE COMPONENTS WILL ONLY BE CREATED ONCE AND WILL NOT REACT TO UPDATES.
     *
     * Explanation: This is intended as a hack to prevent Listings from rendering
     * unnecessarily as a result of mismatches of the following components, which
     * are passed to it as props.
     */

    const { crossSellControlObject } = this.state
    const { pclnBootstrapData } = this.props

    if (
      !this.xSellAd &&
      this.canRenderXSellAd() &&
      pclnBootstrapData?.features?.whiteLabel?.packagesCrossSellEnabled
    ) {
      this.xSellAd = (
        <CrossSellGenericAd
          searchParams={crossSellControlObject}
          flyGaLogic={flyGaLogic}
          seti={seti}
        />
      )
    }
  }

  canRenderXSellAd = () => {
    const { crossSellControlObject } = this.state
    const {
      fetchedInitialListings,
      disableLoadingOverlay,
      listingsIsLoading,
      listingsHasErrored,
    } = this.props

    const displayListings = fetchedInitialListings && !listingsHasErrored
    const showLoadingOverlay =
      !disableLoadingOverlay && listingsIsLoading && !listingsHasErrored

    return (
      get(crossSellControlObject, 'isCrossSell') &&
      displayListings &&
      !showLoadingOverlay
    )
  }

  handlePriceBreakers = () => {
    const { priceBreakersSessionKey } = this.props?.priceBreakers
    const { slicesURL, tripType } = this.state
    const queryParams = querystring.parse(window.location.search)

    const {
      'alt-dates': altDates,
      'cabin-class': cabinClass,
      'num-adults': numAdults,
      'num-children': numChildren,
      'num-infants': numInfants,
      'num-youths': numYouths,
    } = queryParams

    const newQueryParams = {
      'alt-dates': altDates,
      'cabin-class': cabinClass,
      'num-adults': numAdults,
      'num-children': numChildren,
      'num-infants': numInfants,
      'num-youths': numYouths,
      'price-breakers-key': priceBreakersSessionKey,
      'itinerary-type-code': tripType,
    }

    const queryString = querystring.stringify(newQueryParams)

    window.open(
      `/m/fly/search${slicesURL}pricebreakers?${queryString}`,
      '_blank'
    )
  }

  render() {
    if (typeof window === 'undefined') {
      return <LoaderContainer />
    }

    const {
      throttledTrips,
      isSBS,
      isSBSQL,
      seti: setiDetails,
      travelDate,
      returnDate,
      tripType,
      sponsoredCarrier,
      showErrorOverlay,
      tabs,
      selectedDepartureSummaries,
      listings,
      sbsListings,
      minimumRetailPrice,
      isFireFly,
      vipTier,
    } = this.state

    const {
      activeTabId,
      pclnBootstrapData,
      listingsIsLoading,
      listingsHasErrored,
      disableLoadingOverlay,
      fetchedInitialListings,
      displayInfiniteScrollLoadMore,
      brandReference,
      currentMobileFilter,
      listingsMetaData,
      priceBreakers,
      clearFilters,
      filtersLists,
      forceHeaderOpen,
    } = this.props

    const showOriginDate =
      get(pclnBootstrapData, 'searchRequest.params[alt-dates]') === 'true'
    // White Label path code, if the path includes one (ex. /m/fly/search/untd/)
    const whiteLabelPathCode = pclnBootstrapData?.whiteLabelPathCode

    const enableSOPQ =
      pclnBootstrapData?.features?.whiteLabel?.flightsExpressDealsEnabled

    const enableExpressDealVip =
      !isFireFly ||
      (isFireFly && pclnBootstrapData?.features?.flights?.enableExdVip)

    // pass new props to listings down into this object directly instead of feeding it down every single component
    const listingsPropsObject = {}

    const priceBreakersProps = Object.assign({}, priceBreakers, {
      handlePriceBreakers: this.handlePriceBreakers,
    })

    const { searchRequest, features = {} } = pclnBootstrapData
    const defaultFilterAirports = get(
      this.props,
      'filterValues.defaults.AIRPORTS',
      []
    )

    // LaunchDarkly feature toggle for initializing Affirm
    const affirmEnabled = features.whiteLabel?.affirmEnabled

    this.renderStaticElements(setiDetails)

    // Determine which components to display
    const showLoadingOverlay =
      !disableLoadingOverlay && listingsIsLoading && !listingsHasErrored
    const displayListings = fetchedInitialListings && !listingsHasErrored
    const displayLoadMore = displayListings && displayInfiniteScrollLoadMore
    const displayErrorPage = listingsHasErrored && !showLoadingOverlay
    const hasUSDestinationsOnly = pclnBootstrapData.hasUSDestinationsOnly
    const bpgLeftRailDisplay = get(
      setiDetails,
      'AIR_LISTINGS_BPG_PLACEMENT.isVariant',
      false
    )
    const minRetailPrice =
      minimumRetailPrice || get(listingsMetaData, 'minimumRetailPrice', 0)

    const minRetailStops = this.getMinRetailStops()
    const displayFlexDates =
      this.props.calendarPricing &&
      this.props.calendarPricing.length > 0 &&
      displayListings &&
      !showLoadingOverlay
    let flexDatesHelperResults = {}

    // scroll lock for FilterOverlay
    if (this.scrollLock) {
      if (currentMobileFilter) {
        this.scrollLock.on()
      } else {
        this.scrollLock.off()
      }
    }

    // Flex Dates Flyin Logic
    if (get(this, 'flexDates', []) && tripType === 'RT') {
      const departDate = get(searchRequest, 'slices[0].travelDate', '')
      const returnDate = get(searchRequest, 'slices[1].travelDate', '')

      flexDatesHelperResults = flexDatesFlyinHelper(
        this.props.calendarPricing,
        minRetailPrice,
        departDate,
        returnDate,
        this.origin,
        this.destination
      )
    }

    const hasEuropeFlight = airports => {
      let flightIncludesEurope = false
      if (airports) {
        let airportsArray = Object.values(airports)
        airportsArray.forEach(airportStop => {
          if (europeanCountriesList.indexOf(airportStop.countryName) > -1) {
            flightIncludesEurope = true
          }
        })
      }
      return flightIncludesEurope
    }

    let listingsToPassDown = listings
    if (isSBS) {
      listingsToPassDown = sbsListings[activeTabId] || []
    }

    /**
     *  Please DO NOT delete <React.StrictMode>. Used to find issues with React in development
     */
    return (
      // <React.StrictMode>
      <div>
        {/* Mobile Filters */}
        <Route
          path={
            whiteLabelPathCode
              ? this.routingHelper.getRouteWithPathCode(
                  'filters',
                  whiteLabelPathCode
                )
              : RoutingHelper.routePaths.filters
          }
          render={routeProps => {
            if (!fetchedInitialListings) {
              this.routingHelper.goToListings()
              return null
            }

            return <FilterRouteContainer pclnExpt={pclnExpt} {...routeProps} />
          }}
        />

        {/* Listings and merchandising content */}
        <Route
          path={
            whiteLabelPathCode
              ? this.routingHelper.getRouteWithPathCode(
                  'listings',
                  whiteLabelPathCode
                )
              : RoutingHelper.routePaths.listings
          }
          render={routeProps => {
            return (
              <Suspense fallback={<LoaderContainer />}>
                <LazyContentRenderer
                  {...routeProps}
                  affirmEnabled={affirmEnabled}
                  listingsPropsObject={listingsPropsObject}
                  phoneBookInfo={this.state.phoneBookInfo}
                  activeTabId={activeTabId}
                  airportToCity={this.state.airportToCity}
                  altDeals={this.props.altDeals}
                  assetURLs={assetURLs}
                  searchRequest={searchRequest}
                  brandReference={brandReference}
                  calendarPricing={this.props.calendarPricing}
                  calendarPricingExpressDeals={
                    this.props.calendarPricingExpressDeals
                  }
                  closeBaggageFeeOverlay={this.closeBaggageFeeOverlay}
                  closeErrorOverlay={this.closeErrorOverlay}
                  currentMobileFilter={currentMobileFilter}
                  deeplinkModelToken={flyDetailDeeplinkModel.get().token}
                  departingFrom={this.state.departingFrom}
                  destination={this.destination}
                  displayAds={this.props.displayAds}
                  displayErrorPage={displayErrorPage}
                  displayFlexDates={displayFlexDates}
                  displayInfiniteScrollLoadMore={displayInfiniteScrollLoadMore}
                  displayListings={displayListings}
                  displayLoadMore={displayLoadMore}
                  exdCarriers={this.state.exdCarriers}
                  fetchedInitialListings={fetchedInitialListings}
                  flexDatesHelperResults={flexDatesHelperResults}
                  flyGaLogic={flyGaLogic}
                  forceHeaderOpen={forceHeaderOpen}
                  hasUSDestinationsOnly={hasUSDestinationsOnly}
                  handleDepartureSliceClick={this.handleDepartureSliceClick}
                  handleTabChange={this.updateActiveTabIdAndFilters}
                  enableSOPQ={enableSOPQ}
                  isDesktop={this.state.isDesktop}
                  isIE={get(pclnBootstrapData, 'requestLocals.isIE', false)}
                  isSliceSelected={this.state.isSliceSelected}
                  isSBS={isSBS}
                  isSBSQL={isSBSQL}
                  selectedDepartureSummaries={selectedDepartureSummaries}
                  listings={listingsToPassDown}
                  listingsIsLoading={this.props.listingsIsLoading}
                  listingsLoadingMessage={this.props.listingsLoadingMessage}
                  listingsSaleStyle={get(
                    pclnBootstrapData,
                    'saleStyles.listings',
                    {}
                  )}
                  loadingMessage={this.state.loadingMessage}
                  loadMore={this.loadMore}
                  minRetailPrice={minRetailPrice}
                  minRetailStops={minRetailStops}
                  onListingItemSelect={this.onListingItemSelect}
                  onListingsMount={this.onListingsMount}
                  onSliceFilter={this.onSliceFilter}
                  onUpsellSelect={this.onUpsellSelect}
                  openBaggageFeesModal={this.openBaggageFeesModal}
                  origin={this.origin}
                  pclnGptDartAds={pclnGptDartAds}
                  perPaxPricingText={this.perPaxPricingText}
                  hasEuropeFlight={hasEuropeFlight(this.airports)}
                  priceGuidance={this.state.priceGuidance}
                  returnDate={returnDate}
                  returningFrom={this.state.returningFrom}
                  searchKey={this.state.searchKey}
                  searchRefId={this.searchRefId()}
                  SETI={this.props.SETI}
                  setiDetails={setiDetails}
                  showBaggageFeeModal={this.state.showBaggageFeeModal}
                  showErrorOverlay={showErrorOverlay}
                  showLoadingOverlay={showLoadingOverlay}
                  showLoadingScreenServerSide={this.showLoadingScreenServerSide()}
                  slices={this.props.slices}
                  tabs={tabs}
                  sponsoredCarrier={sponsoredCarrier}
                  throttledTrips={throttledTrips}
                  trafficSource={
                    pclnBootstrapData?.requestLocals?.referral?.trafficSource
                  }
                  travelDate={travelDate}
                  tripType={tripType}
                  xSellAd={this.xSellAd}
                  bpgLeftRailDisplay={bpgLeftRailDisplay}
                  defaultFilterAirports={defaultFilterAirports}
                  hasExpressDeal={this.props.hasExpressDeal}
                  listingsMetaData={listingsMetaData}
                  priceBreakersProps={priceBreakersProps}
                  //Added extra argument(pclnExpt.isVarient) in cancellationText callback to test 'AIR_LISTINGS_EXACT_VOID_WINDOW'
                  cancellationText={flightData =>
                    cancellationText(
                      flightData,
                      tripType,
                      pclnExpt.isVariant('AIR_LISTINGS_EXACT_VOID_WINDOW')
                    )
                  }
                  cancelTextColor='text.light'
                  cancelFooterIcon={<Check size={16} mr={1} />}
                  vipTier={!isFireFly ? vipTier : ''}
                  showOriginDate={showOriginDate}
                  clearFilters={clearFilters}
                  filtersLists={filtersLists}
                  enableExpressDealVip={enableExpressDealVip}
                  isFireFly={isFireFly}
                  showFilterChips={pclnExpt.isVariant(
                    'AIR_LISTINGS_FILTER_REDESIGN_SHOW_SELECTED_2'
                  )}
                  searchSlices={get(searchRequest, 'slices', [])}
                />
              </Suspense>
            )
          }}
        />
      </div>
      // </React.StrictMode>
    )
  }
}

ListingsContent.contextTypes = {
  airSearchPromise: PropTypes.object,
}

ListingsContent.propTypes = {
  activeTabId: PropTypes.number,
  airlines: PropTypes.object,
  altDeals: PropTypes.array,
  bpgLeftRailDisplay: PropTypes.bool,
  brandReference: PropTypes.array,
  cacheListings: PropTypes.object,
  calendarPricing: PropTypes.array,
  calendarPricingExpressDeals: PropTypes.array,
  calendarPricingMap: PropTypes.array,
  currentMobileFilter: PropTypes.string,
  disableLoadingOverlay: PropTypes.bool,
  displayAds: PropTypes.bool,
  displayInfiniteScrollLoadMore: PropTypes.bool,
  expressDealInfo: PropTypes.object,
  fetchAirSearchResponse: PropTypes.func,
  fetchedInitialListings: PropTypes.bool,
  fetchFlexDates: PropTypes.func,
  filterValues: PropTypes.object,
  hasExpressDeal: PropTypes.bool,
  history: PropTypes.object,
  lastUpdateTime: PropTypes.string,
  listings: PropTypes.object,
  listingsFilterCall: PropTypes.func,
  listingsHasErrored: PropTypes.bool,
  listingsIsLoading: PropTypes.bool,
  listingsLoadingMessage: PropTypes.string,
  listingsLoadMore: PropTypes.func,
  listingsMetaData: PropTypes.object,
  loadSavedFilterInfo: PropTypes.func,
  pclnBootstrapData: PropTypes.object,
  priceBreakers: PropTypes.object,
  setAirSearchRequest: PropTypes.func,
  setDisplayInfiniteScrollLoadMore: PropTypes.func,
  SETI: PropTypes.array,
  setOverfilteredStatus: PropTypes.func,
  setSearchResults: PropTypes.func,
  setTabDefaultFilters: PropTypes.func,
  slices: PropTypes.array,
  updateActiveTabId: PropTypes.func,
  updateStopsFilters: PropTypes.func,
  fetchExdFlexDates: PropTypes.func,
  clearFilters: PropTypes.func,
  filtersLists: PropTypes.array,
  forceHeaderOpen: PropTypes.func,
  attributeFilterConditions: PropTypes.bool,
  airlinesFilter: PropTypes.array,
}

export { ListingsContent }
